import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { FormHelperText } from "@remo-co/ui-core/src/components/FormHelperText";
import { ImageUploader } from "modules/uploader";
import UploadCaption, { BestUploadSizes } from "modules/uploader/UploadCaption";
import SponsorUploadAndPreview from "modules/eventForm/sponsorship/SponsorUploadAndPreview";
import * as FileStoragePaths from "services/firebaseService/storagePaths";
import { styles } from "./styles";

interface ImageUploaderFieldProps {
  name: string;
  label?: string;
  uploadedImage: string;
  onImageUpload: (url: string) => void;
  onImageDelete: () => void;
  bestSize?: BestUploadSizes;
  dataTestId?: string;
  error?: string;
}

export const ImageUploaderField = ({
  name,
  label,
  uploadedImage,
  onImageUpload,
  onImageDelete,
  bestSize = BestUploadSizes.portrait,
  dataTestId,
  error,
}: ImageUploaderFieldProps) => (
  <Box mb={2} sx={styles.imageUploaderContainer}>
    {label && (
      <Typography variant="subtitle1" mb={1} sx={styles.label}>
        {label}
      </Typography>
    )}
    <ImageUploader
      name={name}
      level={FileStoragePaths.UPLOAD_LEVEL.EVENT}
      path={FileStoragePaths.EVENT_MEDIA}
      onImageUploaded={onImageUpload}
      data-testid={dataTestId || `${name}-uploader`}
      variant="text"
      size="lg"
    >
      <SponsorUploadAndPreview
        onDelete={onImageDelete}
        dataKey={name}
        uploadedImage={uploadedImage}
        helpText={
          <FormHelperText error={!!error}>
            {error || <UploadCaption allowGif bestSize={bestSize} />}
          </FormHelperText>
        }
        sx={styles.imageUploader}
      />
    </ImageUploader>
  </Box>
);
